import { KTSVG } from '_metronic/helpers'
import type { InstallationLineItem } from '../../types'
import { wonFormCheckInput } from '../../formCheckClasses'

interface Props {
  isView: boolean
  items: InstallationLineItem[]
  addItemRow: () => void
  removeItemRow: (id: string) => void
  updateItemRow: (
    id: string,
    field: keyof Omit<InstallationLineItem, 'id'>,
    value: string | boolean
  ) => void
}

const InstallationItemsTableSection: React.FC<Props> = ({
  isView,
  items,
  addItemRow,
  removeItemRow,
  updateItemRow,
}) => {
  return (
    <div className='col-12'>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title fw-bold'>รายการ</div>
          {!isView && (
            <div className='card-toolbar'>
              <button
                type='button'
                className='btn btn-sm btn-light-primary fw-bold'
                onClick={addItemRow}>
                เพิ่มแถว
              </button>
            </div>
          )}
        </div>
        <div className='card-body'>
          <div className='table-responsive'>
            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-2'>
              <thead>
                <tr className='fw-bold text-gray-800'>
                  <th className='min-w-50px'>ที่</th>
                  <th className='min-w-180px'>รายการ</th>
                  <th className='min-w-130px'>ชนิด/แบบ</th>
                  <th className='min-w-80px'>จำนวน</th>
                  <th className='min-w-60px text-center'>รับ</th>
                  <th className='min-w-60px text-center'>จ้าง</th>
                  {!isView && <th className='w-50px' />}
                </tr>
              </thead>
              <tbody>
                {items.map((row, index) => (
                  <tr key={row.id}>
                    <td>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        value={row.no}
                        disabled={isView}
                        placeholder={String(index + 1)}
                        onChange={e => updateItemRow(row.id, 'no', e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        value={row.description}
                        disabled={isView}
                        onChange={e => updateItemRow(row.id, 'description', e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        value={row.typeModel}
                        disabled={isView}
                        onChange={e => updateItemRow(row.id, 'typeModel', e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        value={row.quantity}
                        disabled={isView}
                        onChange={e => updateItemRow(row.id, 'quantity', e.target.value)}
                      />
                    </td>
                    <td className='text-center align-middle'>
                      <input
                        className={wonFormCheckInput}
                        type='checkbox'
                        checked={row.receive}
                        disabled={isView}
                        onChange={e => updateItemRow(row.id, 'receive', e.target.checked)}
                      />
                    </td>
                    <td className='text-center align-middle'>
                      <input
                        className={wonFormCheckInput}
                        type='checkbox'
                        checked={row.hire}
                        disabled={isView}
                        onChange={e => updateItemRow(row.id, 'hire', e.target.checked)}
                      />
                    </td>
                    {!isView && (
                      <td className='text-end'>
                        <button
                          type='button'
                          className='btn btn-sm btn-icon btn-light-danger'
                          onClick={() => removeItemRow(row.id)}
                          disabled={items.length <= 1}>
                          <KTSVG
                            path='/media/icons/duotune/general/gen027.svg'
                            className='svg-icon-1'
                          />
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InstallationItemsTableSection
